export async function submitInquiry(payload) {
  const res = await fetch('/api/inquiry', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload)
  });

  let body = null;
  try {
    body = await res.json();
  } catch (e) {
    body = null;
  }

  if (!res.ok) {
    throw new Error((body && body.error) || ('Request failed with status ' + res.status));
  }
  return body || { ok: true };
}
